module.exports = __webpack_public_path__ + "static/media/placeholder11.73e7567c.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder11.jpg
// module id = 633
// module chunks = 0